import { render, staticRenderFns } from "./kullaniciYetkiler.vue?vue&type=template&id=f7352ef8&scoped=true&"
import script from "./kullaniciYetkiler.vue?vue&type=script&lang=js&"
export * from "./kullaniciYetkiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7352ef8",
  null
  
)

export default component.exports